import { useEffect, useRef } from "react";
import { isEqualObject } from "../utils/FPEUtils";

export const useDeepCompareEffect = (callback, dependencies) => {
  // eslint-disable-next-line
  useEffect(callback, dependencies.map(useMemoizedCompare));
};

const useMemoizedCompare = value => {
  const ref = useRef();
  if (!isEqualObject(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
};